import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import FormTextField from '../form/redux-form/FormTextField';
import validate from 'validate.js';

const validation = values => validate(
  values,
  { reason: { presence: { message: 'Wprowadzenie powodu jest wymagane' } } },
  { fullMessages: false });

let PutBikeOutOfServiceForm = ({ handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Field
          name="reason"
          component={FormTextField}
          label="Powód"
          fullWidth
          multiline
          rows={8}
        />
      </div>
    </form>
  );
};

PutBikeOutOfServiceForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool
};

PutBikeOutOfServiceForm = reduxForm({
  form: 'putBikeOutOfService',
  validate: validation,
})(PutBikeOutOfServiceForm);

export default PutBikeOutOfServiceForm;
